import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import SessionDetailsPage from './components/SessionDetailsPage';
import SessionViewerPage from './components/SessionViewerPage';
import UserAttemptsPage from './components/UserAttemptsPage';
import ScanGradeHomeworkPage from './components/ScanGradeHomeworkPage';
import ScanGradeQuestionPage from './components/ScanGradeQuestionPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const BASENAME = (() => {
  const raw = (process.env as any).PUBLIC_URL || '/';
  try {
    const u = new URL(raw, window.location.origin);
    return u.pathname.replace(/\/$/, '');
  } catch {
    return raw.replace(/\/$/, '');
  }
})();

root.render(
  <React.StrictMode>
    <BrowserRouter basename={BASENAME}>
      <Routes>
        <Route path="/session/:attemptId" element={<SessionDetailsPage />} />
        <Route path="/viewer/:attemptId" element={<SessionViewerPage />} />
        <Route path="/user/attempts" element={<UserAttemptsPage />} />
        <Route path="/scan-grade/homework/:scanGradeHomeworkId" element={<ScanGradeHomeworkPage />} />
        <Route path="/scan-grade/question/:scanGradeId" element={<ScanGradeQuestionPage />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);